/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_To_Top_LabelInputs */

const en_nav_to_top_label = /** @type {(inputs: Nav_To_Top_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to top`)
};

const lv_nav_to_top_label = /** @type {(inputs: Nav_To_Top_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atpakaļ uz augšu`)
};

/**
* | output |
* | --- |
* | "Back to top" |
*
* @param {Nav_To_Top_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_to_top_label = /** @type {((inputs?: Nav_To_Top_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_To_Top_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_to_top_label(inputs)
	return en_nav_to_top_label(inputs)
});